var Acr = Acr || {};

Acr.Slider = function () {

  var $quotesSlider;
  var $quotesSwiperContainer;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $swiperSlides;
  var quotesSwiper;
  const swiperContainerSelector = '.js-swiper-container';
  const swiperPaginationSelector = '.js-swiper-pagination';
  const arrowLeftSelector = '.js-arrow-left';
  const arrowRightSelector = '.js-arrow-right';
  const swiperSlideSelector = '.js-swiper-slide';
  const arrowDisabledClass = 'quotes-container__arrow--disabled';

  // Initialize all HTML selectors
  function initSelectors(element) {
    $quotesSlider = element;
    $quotesSwiperContainer = $quotesSlider.querySelector(swiperContainerSelector);
    $swiperPagination = $quotesSlider.querySelector(swiperPaginationSelector);
    $arrowLeft = $quotesSlider.querySelector(arrowLeftSelector);
    $arrowRight = $quotesSlider.querySelector(arrowRightSelector);
    $swiperSlides = $quotesSlider.querySelectorAll(swiperSlideSelector);
  }

  // Initialize the swiper slider
  function initQuotesSliderSwiper() {
    quotesSwiper = new Swiper($quotesSwiperContainer, {
      slidesPerView: 1,
      slidesPerColumn: 1,
      loop: true,
      pagination: {
        el: $swiperPagination,
        clickable: true,
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft,
      },
      init: false,
    });

    if ($swiperSlides.length > 1) {
      quotesSwiper.init();
    } else {
      $arrowLeft.classList.add(arrowDisabledClass);
      $arrowRight.classList.add(arrowDisabledClass);
    }

    quotesSwiper.on('slideChange', function () {
      if (Acr.TrackingManager && event.type !== 'resize') {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
  }

  function init(element) {
    initSelectors(element);
    initQuotesSliderSwiper();
  }

  return {
    init: init,
  };
};
